import { useState, useEffect } from 'react';
import {
  FilterContainer,
  FilterSection,
  FilterLabel,
  FilterCheckbox,
  FilterSelect,
  FilterDateInput,
  FilterDateRange
} from './filter.styles';

const normalize = (values) => {
  return Object.entries(values).reduce((acc, [key, val]) => {
    if (val === '') return acc;
    if (Array.isArray(val) && val.length === 0) return acc;

    if (val === 'true') acc[key] = true;
    else if (val === 'false') acc[key] = false;
    else acc[key] = val;

    return acc;
  }, {});
};

const Filter = ({ filters, defaultValues = {}, onFilterChange }) => {
  const [values, setValues] = useState(defaultValues);

  // Sync internal values when defaultValues change externally (e.g. browser back/forward)
  useEffect(() => {
    setValues(defaultValues);
  }, [defaultValues]);

  const updateValue = (key, val) => {
    const newValues = { ...values, [key]: val };
    setValues(newValues);
    onFilterChange(normalize(newValues));
  };

  const toggleCheckbox = (key, option) => {
    const raw = values[key] || [];
    const current = Array.isArray(raw) ? raw : [raw];
    const newValue = current.includes(option)
      ? current.filter((v) => v !== option)
      : [...current, option];
    const newValues = { ...values, [key]: newValue };
    setValues(newValues);
    onFilterChange(normalize(newValues));
  };

  return (
    <FilterContainer>
      {filters.map(({ key, label, type, options }) => (
        <FilterSection key={key}>
          <FilterLabel>{label}</FilterLabel>

          {type === 'checkbox' && (
            <FilterCheckbox>
              {options.map((opt) => (
                <label key={opt}>
                  <input
                    type="checkbox"
                    value={opt}
                    checked={[].concat(values[key] || []).includes(opt)}
                    onChange={() => toggleCheckbox(key, opt)}
                  />
                  {opt}
                </label>
              ))}
            </FilterCheckbox>
          )}

          {type === 'select' && (
            <FilterSelect
              value={values[key] ?? ''}
              onChange={(e) => updateValue(key, e.target.value)}
            >
              <option value="">All</option>
              {options.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </FilterSelect>
          )}

          {type === 'text' && (
            <input
              type="text"
              value={values[key] ?? ''}
              onChange={(e) => updateValue(key, e.target.value)}
              placeholder={`Enter ${label}`}
            />
          )}

          {type === 'dateRange' && (
            <FilterDateRange>
              <FilterDateInput
                type="date"
                value={values[`${key}Start`] ?? ''}
                onChange={(e) => updateValue(`${key}Start`, e.target.value)}
              />
              <span>to</span>
              <FilterDateInput
                type="date"
                value={values[`${key}End`] ?? ''}
                onChange={(e) => updateValue(`${key}End`, e.target.value)}
              />
            </FilterDateRange>
          )}
        </FilterSection>
      ))}
    </FilterContainer>
  );
};

export default Filter;
